import { useState } from 'react';
import { Phone, MessageSquare, X } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';
import LiliChatWindow from './LiliChatWindow';

const ConciergeButton = ({ user }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isChatOpen, setIsChatOpen] = useState(false);

  const handleWhatsAppClick = () => {
    const phoneNumber = '+919740877727';
    const message = encodeURIComponent('Hi, I am interested in The Haute Circle');
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
    setIsMenuOpen(false);
  };

  const handleCallClick = () => {
    window.location.href = 'tel:+919740877727';
    setIsMenuOpen(false);
  };

  const handleLiliClick = () => {
    setIsChatOpen(true);
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <>
      {/* Concierge Floating Button */}
      <div className="fixed bottom-6 right-6 z-50">
        {/* Menu Options - Show on Click */}
        {isMenuOpen && (
          <div className="absolute bottom-20 right-0 bg-white rounded-lg shadow-2xl border border-gray-200 overflow-hidden mb-2 animate-in fade-in slide-in-from-bottom-2 duration-200">
            <div className="flex flex-col w-56">
              {/* Lili AI Chatbot */}
              <button
                onClick={handleLiliClick}
                className="flex items-center gap-3 px-5 py-4 hover:bg-[#F5F5DC] transition-colors border-b border-gray-100 group"
              >
                <div className="w-12 h-12 flex items-center justify-center group-hover:scale-110 transition-transform">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_luxury-collective/artifacts/g86n9tir_Lili%20Logo.1-cutout.png" 
                    alt="Lili" 
                    className="w-12 h-12 object-contain"
                  />
                </div>
                <div className="text-left">
                  <p className="font-semibold text-gray-800 text-sm">Chat with Lili</p>
                  <p className="text-xs text-gray-500">AI Concierge</p>
                </div>
              </button>

              {/* WhatsApp */}
              <button
                onClick={handleWhatsAppClick}
                className="flex items-center gap-3 px-5 py-4 hover:bg-[#F5F5DC] transition-colors border-b border-gray-100 group"
              >
                <div className="w-12 h-12 rounded-full bg-green-500 flex items-center justify-center group-hover:scale-110 transition-transform">
                  <FaWhatsapp className="w-7 h-7 text-white" />
                </div>
                <div className="text-left">
                  <p className="font-semibold text-gray-800 text-sm">WhatsApp</p>
                  <p className="text-xs text-gray-500">Instant messaging</p>
                </div>
              </button>

              {/* Call */}
              <button
                onClick={handleCallClick}
                className="flex items-center gap-3 px-5 py-4 hover:bg-[#F5F5DC] transition-colors group"
              >
                <div className="w-12 h-12 rounded-full bg-blue-600 flex items-center justify-center group-hover:scale-110 transition-transform">
                  <Phone className="w-6 h-6 text-white" />
                </div>
                <div className="text-left">
                  <p className="font-semibold text-gray-800 text-sm">Call Us</p>
                  <p className="text-xs text-gray-500">+91 97408 77727</p>
                </div>
              </button>
            </div>
          </div>
        )}

        {/* Main Concierge Button */}
        <button
          onClick={toggleMenu}
          className="w-16 h-16 rounded-full shadow-2xl flex items-center justify-center transition-all duration-300 hover:scale-110 relative group"
          style={{ background: 'linear-gradient(135deg, #D4AF37 0%, #C5A028 100%)' }}
        >
          {isMenuOpen ? (
            <X className="w-7 h-7 text-white" />
          ) : (
            <MessageSquare className="w-7 h-7 text-white" />
          )}
          
          {/* Concierge Label - Visible on Desktop */}
          <span className="absolute -top-12 right-0 bg-black text-white px-4 py-2 rounded-lg text-sm font-semibold whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none shadow-lg hidden md:block">
            Concierge
            <div className="absolute bottom-0 right-6 transform translate-y-1/2 rotate-45 w-2 h-2 bg-black"></div>
          </span>
        </button>
      </div>

      {/* Lili Chat Window */}
      {isChatOpen && (
        <LiliChatWindow 
          user={user}
          onClose={() => setIsChatOpen(false)}
        />
      )}

      {/* Backdrop for Mobile */}
      {isMenuOpen && (
        <div 
          className="fixed inset-0 bg-black/20 z-40 md:hidden"
          onClick={() => setIsMenuOpen(false)}
        />
      )}
    </>
  );
};

export default ConciergeButton;
